/* eslint-disable react-hooks/exhaustive-deps*/
import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import css from './Overview.module.css';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Multiselect } from 'multiselect-react-dropdown';
import Geocoder from '../../../../components/LocationAutocompleteInput/GeocoderMapbox';
import { languages } from '../../../../marketplace-custom-config';
import axios from 'axios';

import DashboardAddButton from '../../../elements/dashboard-add-button/DashboardAddButton';
import config from '../../../../config';
import { getAllPrograms } from '../../../../custom-ducks/programs.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';
// import { SaaSProgramsPageComponent } from '../../../../containers/SaaSProgramsPage/SaaSProgramsPage';
import ReactQuill from 'react-quill';
import ReactHtmlParser from 'react-html-parser';
import { encode, decode } from 'html-entities';
import { notifyError, notifySuccess } from '../../../../components/HotToast/HotToastProvider';
import { brandedConfirmAlert } from '../../../../components/PopupShell/brandedConfirmAlert';
import { Users, Mic, Star, MapPin, ChevronDown, AlertTriangle, Plus } from 'react-feather';

const CATEGORY_OPTIONS = [
  { key: 'coach', icon: Users, title: 'Coach', subtitle: '1:1 & group coaching' },
  { key: 'speaker', icon: Mic, title: 'Speaker', subtitle: 'Talks & workshops' },
  { key: 'mentor', icon: Star, title: 'Mentor', subtitle: 'Long-term guidance' },
];

function Overview(props) {
  const {
    onCreateListingDraft,
    onUpdateListing,
    listing,
    currentUser,
    onGetAllPrograms,
    programs,
    setTabIndex,
    focusField,
  } = props;
  const titleInputRef = useRef(null);
  const programSelectRef = useRef(null);
  const descriptionWrapRef = useRef(null);
  const languageWrapRef = useRef(null);
  const locationInputRef = useRef(null);
  // Only used to read live editor state (current length/selection) and
  // to attach the keydown blocker below — never to mutate the editor's
  // content directly. See onDescriptionChange's comment for why direct
  // Quill mutation caused problems.
  const quillRef = useRef(null);
  // Shared by the focusField deep-link effect below and by validateFields'
  // scroll-to-first-invalid-field behavior, so both stay in sync.
  const FIELD_REFS = {
    title: titleInputRef,
    program: programSelectRef,
    description: descriptionWrapRef,
    language: languageWrapRef,
    location: locationInputRef,
  };
  const scrollToField = fieldKey => {
    const target = FIELD_REFS[fieldKey];
    if (target && target.current) {
      target.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (typeof target.current.focus === 'function') {
        target.current.focus();
      }
    }
  };
  const [inputs, setInputs] = useState({
    category: 'coach',
    title: '',
    // description: '',
    language: [],
    location: '',

    program: 'select',
  });
  const [description, setDescription] = useState();
  const [geo, setGeo] = useState({ lat: 1, lng: 1 });
  const [locations, setLocations] = useState([]);
  const [errors, setErrors] = useState([]);
  // Per-field error message, shown inline right under the offending
  // field (in addition to the summary list) so the coach doesn't have to
  // guess which of several possible issues is theirs.
  const [fieldErrors, setFieldErrors] = useState({});
  // True right after onDescriptionChange truncates a paste at the 3000
  // character cap — surfaces a small notice next to the counter so the
  // coach knows why their pasted text got cut short, instead of just
  // silently landing at "3000/3000" with no explanation.
  const [descriptionLimitHit, setDescriptionLimitHit] = useState(false);

  // AI description assistant ("Optimize with AI", Gemini-backed via
  // /api/ai/optimize-ad-description). Mirrors SaaSSessionEditPage's
  // description assistant.
  const [aiBusy, setAiBusy] = useState(false);
  const [aiError, setAiError] = useState(null);
  const [aiAvailable, setAiAvailable] = useState(true);

  const isNew = () => {
    return listing.id === null;
  };

  // Cheap, unauthenticated probe — hides the AI assistant entirely when
  // GEMINI_API_KEY isn't configured, instead of showing a button that's
  // guaranteed to fail. Fails closed on error.
  useEffect(() => {
    axios
      .get('/api/ai/optimize-ad-description/status')
      .then(res => {
        if (!res.data || res.data.available !== true) {
          setAiAvailable(false);
        }
      })
      .catch(() => setAiAvailable(false));
  }, []);

  useEffect(() => {
    if (!isNew()) {
      setInputs({
        ...inputs,
        category:
          listing.attributes.publicData && listing.attributes.publicData.category
            ? listing.attributes.publicData.category
            : 'coach',
        title: listing.attributes.title || '',
        // description: listing.attributes.description || '',
        language: listing.attributes.publicData.language || '',
        location:
          listing.attributes.publicData && listing.attributes.publicData.location
            ? listing.attributes.publicData.location.address
            : '',
        program:
          listing.attributes.publicData && listing.attributes.publicData.programId
            ? listing.attributes.publicData.programId
            : '',
      });
      setDescription(listing.attributes.description);
    }

    if (listing.attributes.geolocation) {
      setGeo({ lat: listing.attributes.geolocation.lat, lng: listing.attributes.geolocation.lng });
    }

    onGetAllPrograms();
  }, []);

  // Jump to and focus a specific field when arriving here because the
  // "Activate" check on a closed ad found it missing.
  useEffect(() => {
    if (!focusField) return;
    scrollToField(focusField);
  }, []);

  // Block typing once the description is at the 3000-character cap,
  // instead of letting the keystroke land and then silently trimming it
  // back off on the next onChange (which still works, via
  // onDescriptionChange's truncation branch, but feels like the field
  // "ate" whatever was typed). Only blocks plain character input —
  // navigation, deletion, and keyboard shortcuts always pass through,
  // and typing over an active selection is allowed even at the cap
  // since it replaces rather than grows the content. Reads directly off
  // the live Quill instance rather than the `description` state so it's
  // never a render behind.
  useEffect(() => {
    const quill = quillRef.current && quillRef.current.getEditor();
    if (!quill) return;

    const handleKeyDown = event => {
      const isPrintableKey = event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey;
      if (!isPrintableKey) return;

      const selection = quill.getSelection();
      if (selection && selection.length > 0) return;

      const currentLength = quill.getText().replace(/\n$/, '').length;
      if (currentLength >= 3000) {
        event.preventDefault();
      }
    };

    quill.root.addEventListener('keydown', handleKeyDown);
    return () => quill.root.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Explicit hex colours (not CSS vars) so selected-language chips stay
  // visible even when var(--marketplaceColorMid) doesn't resolve in the
  // multiselect library's inline style context.
  const isVCoachTheme =
    typeof document !== 'undefined' &&
    document.body.classList.contains('v-coach-theme');
  const chipBg = isVCoachTheme ? '#7C3AED' : '#0D9488';
  const dropdownStyle = {
    chips: {
      background: chipBg,
      color: '#FFFFFF',
      borderRadius: '999px',
      minHeight: '40px',
    },
    searchBox: {
      border: '1px solid #D1D5DB',
      borderRadius: '10px',
      minHeight: '52px',
    },
    option: { backgroundColor: 'white', color: '#666666' },
  };

  const geocoder = new Geocoder();

  const onLocationChange = e => {
    e.persist();
    setInputs({ ...inputs, location: e.target.value });
    geocoder
      .getPlacePredictions(e.target.value && e.target.value.length > 0 ? e.target.value : '')
      .then(res => {
        setLocations(res.predictions);
        if (res.predictions.length > 0) {
          setGeo({ lat: res.predictions[0].center[1], lng: res.predictions[0].center[0] });
        }
      })
      .catch(err => {
        console.log(err);
        setLocations([]);
      });
  };

  const multiselectToState = e => {
    let tempArray = [];
    for (let index = 0; index < e.length; index++) {
      tempArray.push(e[index].key);
    }
    return tempArray;
  };

  const validateFields = () => {
    let validationErrors = [];
    let newFieldErrors = {};
    let isValid = true;
    let firstInvalidField = null;
    const markInvalid = (field, message) => {
      validationErrors.push(message);
      newFieldErrors[field] = message;
      if (!firstInvalidField) firstInvalidField = field;
      isValid = false;
    };
    const { title, language, location } = inputs;

    if (title.length < 10) {
      markInvalid('title', 'Title should at least be 10 characters long.');
    }

    // Program is optional, not a hard requirement — see the "Add now" /
    // "Continue without a program" popup in onSaveOverview instead of a
    // blocking validation error here.

    const formattedDescription = decode(description).replace(/<[^>]+>/g, '');
    if (formattedDescription.length <= 500) {
      markInvalid('description', 'Description should at least be 500 characters long.');
    }

    if (language.length < 1) {
      markInvalid('language', 'Add at least 1 language.');
    }

    if (location.length < 1) {
      markInvalid('location', 'Add a location.');
    }

    setErrors(validationErrors);
    setFieldErrors(newFieldErrors);

    // Jump straight to whichever required field the coach missed first,
    // instead of leaving them to hunt for it via the summary list at the
    // bottom of the page.
    if (!isValid && firstInvalidField) {
      scrollToField(firstInvalidField);
    }

    return isValid;
  };

  // advance=true is the original "Continue" behavior — validate, save,
  // move to the Services tab. advance=false is "Save draft" — same
  // validate + save, but stays on Overview instead of navigating on.
  // For a brand-new listing, the very first save still has to create the
  // draft and land on its real /l/edit/{id}/... URL (there's no draft to
  // "stay on" until it exists) — it just targets the overview tab
  // instead of service, so DashboardAddListingWrapper's
  // `params.slug === 'edit'` effect keeps tabIndex at 0 and the listing
  // prop syncs to the new id. That avoids a second "Save draft" click
  // calling onCreateListingDraft again and creating a duplicate listing.
  const onSaveOverview = advance => {
    let tempObj = { publicData: {} };

    tempObj.publicData.author = currentUser
      ? `${currentUser.attributes.profile.firstName} ${currentUser.attributes.profile.lastName}`
      : '';

    if (inputs.title) {
      tempObj.title = inputs.title;
    }

    // 'select' is just the placeholder option — only a real pick counts.
    // Program is optional (see the skip-confirmation below), so a coach
    // who never touches this field should save with no programId at all,
    // not the literal string "select".
    if (inputs.program && inputs.program !== 'select') {
      tempObj.publicData.programId = inputs.program;
    }

    // if (inputs.description) {
    //   tempObj.description = inputs.description;
    // }

    if (description) {
      tempObj.description = description;
    }

    if (geo) {
      tempObj.geolocation = geo;
    }

    if (inputs.location) {
      tempObj.publicData.location = { address: inputs.location };
    }

    if (inputs.language) {
      tempObj.publicData.language = inputs.language;
    }

    if (inputs.category) {
      tempObj.publicData.category = inputs.category;
    }

    console.log({ tempObj });

    const callListingService = id => {
      axios
        .post(
          `${config.listingService}set-premium`,
          { id: id },
          {
            headers: {
              'content-type': 'application/json',
            },
          }
        )
        .then(res => {
          console.log(res);
        });
    };

    const doSave = () => {
      if (isNew()) {
        onCreateListingDraft(tempObj).then(res => {
          setErrors([]);
          const newId = res.data.data.id.uuid;
          callListingService(newId);
          notifySuccess(advance ? 'Created' : 'Draft saved');
          if (advance) {
            props.history.push(`/l/edit/${newId}/edit/service`);
            setTabIndex(1);
          } else {
            props.history.push(`/l/edit/${newId}/edit/overview`);
          }
        });
      } else {
        onUpdateListing('description', { ...tempObj, id: listing.id }).then(res => {
          setErrors([]);
          notifySuccess(advance ? 'Saved' : 'Draft saved');
          if (advance) {
            props.history.push(`/l/edit/${res.data.data.id.uuid}/edit/service`);
            setTabIndex(1);
          }
        });
      }
    };

    // console.log(tempObj);
    if (validateFields()) {
      // Program is optional, but a coach who hasn't linked one yet gets a
      // heads-up before we save — "Add now" jumps them to the field
      // instead of saving; "Continue without a program" (or "Save
      // without a program" for a draft save) proceeds as normal.
      if (inputs.program === 'select') {
        brandedConfirmAlert({
          title: 'No program linked yet',
          message:
            "This ad isn't linked to a coaching program yet. You can add one now, or skip it and add one later — clients just won't be auto-assigned to a program until you do.",
          tone: 'warning',
          buttons: [
            { label: 'Add now', onClick: () => scrollToField('program') },
            {
              label: advance ? 'Continue without a program' : 'Save without a program',
              onClick: doSave,
            },
          ],
        });
        return;
      }

      doSave();
    } else {
      console.log('Has non valid input(s)');
      notifyError('Has non valid input(s)');
    }
  };

  const getMultiSelectedValues = name => {
    let tempArray = [];
    if (listing.attributes.publicData[name]) {
      for (let i = 0; i < listing.attributes.publicData[name].length; i++) {
        tempArray[i] = {
          key: listing.attributes.publicData[name][i],
          label: listing.attributes.publicData[name][i],
        };
      }
    }
    return tempArray;
  };

  // ReactQuill is deliberately UNCONTROLLED here (no `value` prop, see
  // the <ReactQuill> element below) — only `defaultValue` to seed initial
  // content once on mount. Two earlier attempts kept it controlled
  // (pushing `description` state back in via `value` on every change) to
  // enforce the 3000-char cap, and both broke in different ways:
  //   1. Truncating with a 'silent' Quill event left react-quill's own
  //      internal content tracking (`this.state.value`) stale, which
  //      then made it "reconcile" the live editor back to that stale
  //      value on the next render — corrupting the field.
  //   2. Truncating the HTML *string* (not touching Quill directly) fixed
  //      that, but ANY edit — not just truncation — still round-tripped
  //      `description` state back through the controlled `value` prop.
  //      Whenever that round trip wasn't byte-identical to what Quill
  //      already had (encode/decode + Quill's own re-serialization aren't
  //      guaranteed to be perfectly stable), react-quill would "reconcile"
  //      and snap the editor back — which is why removing text after
  //      hitting the cap could appear to silently undo itself.
  // Going uncontrolled removes the entire class of bugs: there's no prop
  // for react-quill to reconcile against, so nothing it does can ever
  // reset the live editor out from under the coach. `description` state
  // still tracks the content (for the counter, save, and AI assist) —
  // it's just one-way now (editor -> state), and truncation/AI-generated
  // text are applied imperatively straight to the live editor via
  // `quillRef` instead of round-tripping through props.
  const onDescriptionChange = html => {
    const quill = quillRef.current && quillRef.current.getEditor();
    const currentLength = quill
      ? quill.getText().replace(/\n$/, '').length
      : html.replace(/<[^>]+>/g, '').length;

    if (currentLength <= 3000) {
      setDescription(encode(html));
      setDescriptionLimitHit(currentLength === 3000);
      return;
    }

    // Over the limit — can only happen via paste (the keydown blocker
    // below prevents plain typing past the cap). Truncate the live
    // editor directly; this fires another (non-silent) text-change that
    // re-enters this function with the now-exactly-3000 content, which
    // takes the branch above and settles there — no dueling state since
    // there's no `value` prop for react-quill to fight over.
    if (!quill) {
      setDescription(encode(html));
      setDescriptionLimitHit(true);
      return;
    }
    quill.deleteText(3000, currentLength - 3000);
    setDescription(encode(quill.root.innerHTML));
    setDescriptionLimitHit(true);
  };

  // Calls the Gemini-backed description assistant
  // (server/api/ai/optimizeAdDescription.js) to polish whatever's already
  // in the editor.
  const callDescriptionAssistant = async () => {
    if (aiBusy) return;
    setAiBusy(true);
    setAiError(null);
    try {
      const res = await axios.post('/api/ai/optimize-ad-description', {
        text: descriptionOnlyText,
        adTitle: inputs.title,
        category: inputs.category,
      });
      const generated = res.data && res.data.text;
      if (generated) {
        // Server already returns formatted HTML (intro + bullets, see
        // geminiClient.js's formatAiText).
        const html = generated;
        // ReactQuill is uncontrolled (see onDescriptionChange's comment),
        // so setting `description` state alone wouldn't touch the live
        // editor. Apply the AI text straight to the editor instead —
        // that fires a normal text-change, which calls onDescriptionChange
        // for us and keeps `description` state in sync the same way a
        // real paste does.
        const quill = quillRef.current && quillRef.current.getEditor();
        if (quill) {
          quill.setContents(quill.clipboard.convert(html));
        } else {
          onDescriptionChange(html);
        }
      } else {
        setAiError('Could not generate text right now — please try again.');
      }
    } catch (err) {
      const status = err.response && err.response.status;
      if (status === 429) {
        const retryAfter = err.response.data && err.response.data.retryAfterSeconds;
        setAiError(
          retryAfter
            ? `You've hit the AI assist limit — try again in ${retryAfter}s.`
            : "You've hit the AI assist limit — try again shortly."
        );
      } else if (!err.response || status === 503) {
        // Endpoint unreachable or key missing/model overloaded — hide the
        // assistant rather than leaving a button up that will just keep
        // failing.
        setAiAvailable(false);
      } else {
        setAiError('Could not generate text right now — please try again.');
      }
    } finally {
      setAiBusy(false);
    }
  };

  // light-v10 (rather than streets-v10) reads closer to the pastel
  // service-area preview in the redesign; the pin is now drawn as a CSS
  // overlay below instead of baked into the static image, so it can sit
  // on top of the "Approximate service area" legend pill.
  const src =
    'https://api.mapbox.com/styles/v1/mapbox/light-v10/static' +
    `/${geo.lng},${geo.lat},${4}` +
    `/${1200}x${600}` +
    `?access_token=${config.maps.mapboxAccessToken}`;

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      [
        'link',
        // 'image'
      ],
      ['clean'],
    ],
  };

  const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    // 'image',
  ];

  const descriptionOnlyText = decode(description).replace(/<[^>]+>/g, '');

  return (
    <div className={css.wrapper}>
      <div className={css.pageHeading}>
        <h2 className={css.pageTitle}>Listing overview</h2>
        <p className={css.pageSubtitle}>
          Set the basics for your ad — clients will see this information first.
        </p>
      </div>

      <div className={css.category}>
        <p className={css.label}>Selected category</p>
        <p className={css.info}>Choose the role that best describes how you'll work with clients.</p>
        <div className={css.categoryGrid}>
          {CATEGORY_OPTIONS.map(opt => {
            const Icon = opt.icon;
            const selected = inputs.category === opt.key;
            return (
              <div
                key={opt.key}
                className={`${css.categoryCard} ${selected ? css.categoryCardSelected : ''}`}
                onClick={() => setInputs({ ...inputs, category: opt.key })}
                role="radio"
                aria-checked={selected}
                tabIndex={0}
              >
                <div
                  className={`${css.categoryIconBadge} ${
                    selected ? css.categoryIconBadgeSelected : ''
                  }`}
                >
                  <Icon size={18} />
                </div>
                <div className={css.categoryText}>
                  <div className={css.categoryTitle}>{opt.title}</div>
                  <div className={css.categorySubtitle}>{opt.subtitle}</div>
                </div>
                <div
                  className={`${css.categoryRadio} ${
                    selected ? css.categoryRadioSelected : ''
                  }`}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className={css.title}>
        <p className={css.label}>Listing title</p>
        <p className={css.info}>Write a clear, attention-grabbing title that describes your service — e.g. "Executive Leadership Coaching for New Managers"</p>
        <input
          ref={titleInputRef}
          value={inputs.title}
          onChange={e => setInputs({ ...inputs, title: e.target.value.substring(0, 150) })}
          className={`${css.input} ${fieldErrors.title ? css.inputError : ''}`}
          type="text"
          placeholder="e.g. Career Transition Coaching for Professionals"
        />
        {fieldErrors.title && <p className={css.fieldError}>{fieldErrors.title}</p>}
        <p className={css.info}>{inputs.title.length} / 150 · minimum 10 characters</p>
      </div>

      <div className={css.program}>
        <p className={css.label}>Select a program <span className={css.optionalTag}>(optional)</span></p>
        <p className={css.info}>Link this ad to one of your coaching programs. When a client purchases this ad, they're automatically assigned to the selected program.</p>

        {programs && programs.length > 0 ? (
          <div className={css.selectWrap}>
            <select
              ref={programSelectRef}
              className={css.select}
              value={inputs.program}
              onChange={e => setInputs({ ...inputs, program: e.target.value })}
            >
              <option className={css.label} value="select">
                Select A Program
              </option>
              {programs.map((item, index) => {
                return (
                  <option className={css.label} key={index} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
            <ChevronDown size={18} className={css.selectChevron} />
          </div>
        ) : (
          <div ref={programSelectRef} className={css.programWarning}>
            <div className={css.programWarningIconWrap}>
              <AlertTriangle size={18} />
            </div>
            <div className={css.programWarningBody}>
              <p className={css.programWarningTitle}>Please add a program</p>
              <p className={css.programWarningText}>
                You don't have any coaching programs yet. Create one so clients are
                automatically assigned to it the moment they purchase this ad.
              </p>
              <button
                type="button"
                className={css.createProgramButton}
                onClick={() =>
                  props.history.push({
                    pathname: '/v-coach/programs',
                    state: { openCreate: true },
                  })
                }
              >
                <Plus size={14} /> Create a program
              </button>
            </div>
          </div>
        )}
      </div>

      <div ref={descriptionWrapRef} className={css.description}>
        <p className={css.label}>Detailed description</p>
        <p className={css.info}>Describe your service for potential clients. Focus on the outcomes you deliver, any testimonials, and your coaching process. Minimum 500 characters.</p>
        {/*        <textarea*/}
        {/*          value={inputs.description}*/}
        {/*          onChange={e => setInputs({ ...inputs, description: e.target.value.substring(0, 3000) })}*/}
        {/*          className={css.input}*/}
        {/*          rows="10"*/}
        {/*          placeholder={`*/}
        {/*Describe your service for new clients. Focus on:*/}

        {/*1.The outcomes & results you produce for clients - WIIFM 'What's In It For Me'*/}
        {/*2.Testimonials - the success you have brought other clients.*/}
        {/*3.Lastly, mention your process.`}*/}
        {/*        />*/}

        {aiAvailable && (
          <div className={css.aiAssistant}>
            <p className={css.aiHint}>
              Already have a draft? Let AI polish it — clearer wording, same facts.
            </p>
            <div className={css.aiButtons}>
              <button
                type="button"
                className={css.aiButton}
                disabled={aiBusy || !descriptionOnlyText.trim()}
                onClick={() => callDescriptionAssistant()}
              >
                {aiBusy ? 'Working…' : '✨ Optimize with AI'}
              </button>
            </div>
            {aiError && <div className={css.aiError}>{aiError}</div>}
          </div>
        )}

        <ReactQuill
          ref={quillRef}
          // Uncontrolled — `defaultValue` only, no `value` prop. Seeded
          // straight from the `listing` PROP (not the `description`
          // state, which the mount effect above only populates
          // asynchronously) so an existing ad's description is actually
          // there on first paint instead of racing that effect and
          // rendering blank.
          defaultValue={decode(!isNew() ? listing.attributes.description || '' : '')}
          onChange={e => onDescriptionChange(e)}
          modules={quillModules}
          formats={quillFormats}
        />
        {fieldErrors.description && <p className={css.fieldError}>{fieldErrors.description}</p>}
        {descriptionLimitHit && (
          <p className={css.limitNotice}>Maximum length reached — extra text beyond 3000 characters was trimmed.</p>
        )}
        <p className={css.info}>{descriptionOnlyText.length}/3000 max</p>
      </div>
      <div ref={languageWrapRef} className={css.language}>
        <p className={css.label}>Language</p>
        <p className={css.info}>Select all languages you can coach in. Clients can filter by language on the marketplace.</p>
        <Multiselect
          onRemove={e => setInputs({ ...inputs, language: multiselectToState(e) })}
          onSelect={e => setInputs({ ...inputs, language: multiselectToState(e) })}
          style={dropdownStyle}
          options={languages}
          displayValue="label"
          selectedValues={getMultiSelectedValues('language')}
        />
        {fieldErrors.language && <p className={css.fieldError}>{fieldErrors.language}</p>}
      </div>
      <div className={css.location}>
        <p className={css.label}>City</p>
        <p className={css.info}>Enter your city or the location where you offer in-person sessions. This helps clients find coaches near them.</p>
        <div className={css.inputIconWrap}>
          <MapPin size={16} className={css.inputIcon} />
          <input
            ref={locationInputRef}
            list="addListingLocation"
            value={inputs.location}
            onChange={onLocationChange}
            className={`${css.input} ${css.inputWithIcon} ${fieldErrors.location ? css.inputError : ''}`}
            type="text"
            placeholder="e.g. Berlin, Germany"
          />
        </div>
        {fieldErrors.location && <p className={css.fieldError}>{fieldErrors.location}</p>}
        <datalist id="addListingLocation">
          {locations.map((item, index) => (
            <option className={css.locationOptions} key={index}>
              {item.place_name_en}
            </option>
          ))}
        </datalist>
      </div>
      <div className={css.map}>
        <div className={css.mapLegend}>
          <span className={css.mapLegendDot} />
          Approximate service area
        </div>
        <img alt={'map'} src={src} />
        <MapPin size={34} className={css.mapPin} strokeWidth={2.5} />
      </div>
      <div className={css.errors}>
        {errors.map((item, index) => (
          <p key={index} className={css.error}>
            {item}
          </p>
        ))}
      </div>

      <div className={css.footerBar}>
        <span className={css.footerStep}>Step 1 of 3 — Overview</span>
        <div className={css.footerActions}>
          <button
            type="button"
            className={css.saveDraftButton}
            onClick={() => onSaveOverview(false)}
          >
            Save draft
          </button>
          <button
            type="button"
            className={css.continueButton}
            onClick={() => onSaveOverview(true)}
          >
            Continue <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  const { programs, programs_error, programs_fetching } = state.programs;
  return {
    programs:
      programs &&
      programs.map(x => {
        return { id: x.id, name: x.name };
      }),
    programs_error,
    programs_fetching,
  };
};

const mapDispatchToProps = dispatch => ({
  onGetAllPrograms: () => {
    dispatch(getAllPrograms());
  },
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Overview);
